/**
 * Sandeep Sirohi
 * [09/08/2023]
 * User service for caching and getting user related information accross the application.
 * More functions can be added as per the requirement.
 */


import { acquireAccessToken, initilizeMsal, loginRequest } from "../azure/authConfig";
import httpService from "./httpService";
import { AES, enc } from 'crypto-js';
import { Utf8 } from 'crypto-js/enc-utf8';
import jwt_decode from 'jwt-decode'
import { msalInstance } from "..";
/*var jwt = require("jsonwebtoken");*/

/**
 * Sandeep: encrypts the data.
 * @param data
 * @returns
 */
const AESkey = "x1e2t3e4c5h";
//export const encrypt = (data) => {
//    return data ? AES.encrypt(JSON.stringify(data), AESkey).toString() : null;
//}

/**
 * Sandeep: decrypts the data.
 * @param data
 * @returns
 */
//export const decrypt = (data) => {
//    var bytes = data ? AES.decrypt(data, AESkey) : null;
//    let ttt = JSON.parse(bytes.toString(Utf8));
//    let yyy = JSON.parse(JSON.stringify(bytes.toString(Utf8)));
//    return (bytes ? JSON.parse(bytes.toString(Utf8)) : null);
//   // return (bytes ? JSON.parse(JSON.stringify(bytes.words.toString(Utf8))) : null);
//}

/**
 * Sandeep: Get complete user infor including setting,permission and other cached items.
 * @param key
 * @returns
 */
export const getUserInfo = (key) => {
    let userInfo = {
        User: getCacheItem('User'),
        UserPermission: getCacheItem('UserPermission'),
        UserSetting: getCacheItem('UserSetting'),
        SystemSetting: getCacheItem('SystemSetting'),
    }
    return userInfo;
}

/**
 * Sandeep: Get cahce value by key
 * @param key
 * @returns
 */
export const getCacheItem = (key) => {
    let item = sessionStorage.getItem(key);
    if (isJsonString(item)) {
        return JSON.parse(item);
    } else {
        return item
    }
    //return decrypt(item);
}

export const isJsonString = (str) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

/**
 * Sandeep: Helper methods for getting user info and cache them.
 * Extract email from the token to get user info.
 * @param callback
 */

export const initilizeUserInfo = async (callback: any) => {
    await acquireAccessToken(msalInstance).then(token => {
        if (token) {
            let tokenInfo = jwt_decode(token.idToken ? token.idToken : token.accessToken);
            httpService.get(setting.baseAPIUrl + `Auth/UserInfo/${tokenInfo.emails[0]}`,
                {
                    //Sandeep: Adding token and ClientId. ClientId is for Ocelot rate limiting.
                    headers: { 'Authorization': 'Bearer ' + token.accessToken, 'ClientId': tokenInfo.oid }
                }).then(res => {
                    if (res.data) {
                        sessionStorage.setItem("Token", JSON.stringify(token.accessToken));
                        sessionStorage.setItem("User", JSON.stringify(res.data.user));
                        sessionStorage.setItem("UserPermission", JSON.stringify(res.data.userPermission));
                        sessionStorage.setItem("UserSetting", JSON.stringify(res.data.userSetting));
                        sessionStorage.setItem("SystemSetting", JSON.stringify(res.data.systemSetting));
                        sessionStorage.setItem("LookupValue", JSON.stringify(res.data.lookupValue));

                        //Sandeep: Execute the callback for further processing once cache is set.
                        if (callback) setTimeout(() => { callback(res.status); }, 0);
                    }
                }).catch((reason) => {

                    if (callback) callback(reason && reason.response && reason.response.status);
                });
        }
    });
}

/**
 * Get a list of system setting, in case we want setttings to be cached without user logged in in to the system.
 * User login will override existing settings values in the cache.
 */
export const initilizeSystemSetting = async () => {
    await httpService.get(setting.baseAPIUrl + `Website/SystemSetting`).then(res => {
        if (res.data) {
            sessionStorage.setItem("SystemSetting", JSON.stringify(res.data));
        }
    });
}


/**
 * Sandeep: Get lookup value from the cache. 
 * @param securityObject
 * @returns
 */
export const getLookupValue = (lookupName) => {
    let lookupValaue = getCacheItem("LookupValue");
    return lookupValaue && lookupValaue.filter((item) => item.LookupName === lookupName) || null;
}

/**
 * Sandeep: Get user permission based on security object from the cache. 
 * @param securityObject
 * @returns
 */
export const getPermission = (securityObject) => {
    let permission = getCacheItem("UserPermission");
    return permission && permission.length > 0 && permission.find((item) => item.securityObject === securityObject) || null;
}

/**
 * Sandep: return cached token after decrypting it.
 * @returns
 */
export const getToken = () => {
    return getCacheItem("Token");
}

/**
 * Sandep: return oid from access token.
 * @returns
 */
export const getOid = () => {
    return getCacheItem("Token").oid;
}

/**
 * Sandeep: Get logged in user id from cache.
 * @param securityObject
 * @returns
 */
export const getUserId = () => {
    let userInfo = getCacheItem("User");
    return userInfo && userInfo.UserId || null;
}


/**
 * Sandeep: Get logged in user domain.
 * @returns
 */
export const getUserDomain = () => {
    let userInfo = getCacheItem("User");
    return userInfo && userInfo.Domain || null;
}


/**
 * Sandeep: Get cached setting.
 * @returns
 */
export const getSettingValue = (name) => {
    let setting = getCacheItem("SystemSetting");
    if (setting == 'undefined') {
        setting = [];
    }
    let value = setting ? setting.find((x) => x.Name == name) : null;
    return value && value.Value || null;
}

/**
 * Sandeep: Get required permission for the logged in user from cache.
 * Read,Add,Edit,Delete and Grant permission getter.
 * @param securityObject
 * @returns
 */
export const hasReadPermission = (securityObject) => {
    if (!securityObject) return true;
    var permission = getPermission(securityObject);
    return permission ? permission.readPermission : false;
}

export const hasAddPermission = (securityObject) => {
    if (!securityObject) return true;
    var permission = getPermission(securityObject);
    return permission ? permission.addPermission : false;
}

export const hasDeletePermission = (securityObject) => {
    if (!securityObject) return true;
    var permission = getPermission(securityObject);
    return permission ? permission.deletePermission : false;
}

export const hasEditPermission = (securityObject) => {
    if (!securityObject) return true;
    var permission = getPermission(securityObject);
    return permission ? permission.editPermission : false;
}

export const hasGrantPermission = (securityObject) => {
    if (!securityObject) return true;
    var permission = getPermission(securityObject);
    return permission ? permission.grantPermission : false;
}